import { render, staticRenderFns } from "./HomeAccordion.vue?vue&type=template&id=311a8382&scoped=true"
import script from "./HomeAccordion.vue?vue&type=script&lang=js"
export * from "./HomeAccordion.vue?vue&type=script&lang=js"
import style0 from "./HomeAccordion.vue?vue&type=style&index=0&id=311a8382&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "311a8382",
  null
  
)

export default component.exports